/**
 * Product Media Thumbnail Navigation
 * Handles desktop navigation for product media gallery with thumbnail layout.
 * Extends native SliderComponent functionality.
 */
(function() {
  'use strict';
  
  function isThumbnailLayoutDesktop(sliderComponent) {
    const mediaGallery = sliderComponent.closest('media-gallery');
    const isThumbnailLayout = mediaGallery && 
      mediaGallery.dataset.desktopLayout && 
      mediaGallery.dataset.desktopLayout.includes('thumbnail');
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const isSideNav = sliderComponent.nextButton && sliderComponent.nextButton.closest('.slider-buttons--side-nav');
    
    return isThumbnailLayout && isDesktop && isSideNav && mediaGallery;
  }
  
  function handleThumbnailNavigation(sliderComponent, event) {
    const mediaGallery = sliderComponent.closest('media-gallery');
    if (!mediaGallery || !mediaGallery.setActiveMedia) return false;
    
    const allMediaItems = Array.from(sliderComponent.slider.querySelectorAll('li[data-media-id]'));
    if (allMediaItems.length === 0) return false;
    
    const activeMedia = allMediaItems.find(item => item.classList.contains('is-active'));
    if (!activeMedia) return false;
    
    const currentIndex = allMediaItems.indexOf(activeMedia);
    let targetIndex;
    
    if (event.currentTarget.name === 'next') {
      targetIndex = (currentIndex + 1) % allMediaItems.length;
    } else {
      targetIndex = currentIndex - 1;
      if (targetIndex < 0) targetIndex = allMediaItems.length - 1;
    }
    
    const targetMedia = allMediaItems[targetIndex];
    if (!targetMedia) return false;
    
    const targetMediaId = targetMedia.dataset.mediaId;
    const thumbnails = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
    
    if (thumbnails) {
      let targetThumbnail = thumbnails.querySelector(`[data-target="${targetMediaId}"]`);
      if (!targetThumbnail && targetMediaId) {
        const mediaIdParts = targetMediaId.split('-');
        const mediaIdNumber = mediaIdParts[mediaIdParts.length - 1];
        const allThumbnails = thumbnails.querySelectorAll('[data-target]');
        targetThumbnail = Array.from(allThumbnails).find(thumb => {
          const thumbTarget = thumb.dataset.target;
          return thumbTarget === targetMediaId || thumbTarget.endsWith('-' + mediaIdNumber) || thumbTarget === mediaIdNumber;
        });
      }
      
      if (targetThumbnail) {
        const thumbnailButton = targetThumbnail.querySelector('button');
        if (thumbnailButton) {
          thumbnailButton.click();
          return true;
        }
      }
    }
    
    try {
      mediaGallery.setActiveMedia(targetMediaId, false);
      return true;
    } catch (e) {
      return false;
    }
  }
  
  function updateThumbnailButtonStates(sliderComponent) {
    const allMediaItems = Array.from(sliderComponent.slider.querySelectorAll('li[data-media-id]'));
    const activeMedia = allMediaItems.find(item => item.classList.contains('is-active'));
    
    if (activeMedia) {
      const currentIndex = allMediaItems.indexOf(activeMedia);
      const isFirst = currentIndex === 0;
      const isLast = currentIndex === allMediaItems.length - 1;
      
      sliderComponent.prevButton.toggleAttribute('disabled', isFirst);
      sliderComponent.nextButton.toggleAttribute('disabled', isLast);
      return true;
    }
    return false;
  }
  
  function setupThumbnailObservers(sliderComponent) {
    const mediaGallery = sliderComponent.closest('media-gallery');
    if (!mediaGallery) return;
    
    let rafPending = false;
    const mediaObserver = new MutationObserver(() => {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(() => {
          rafPending = false;
          if (isThumbnailLayoutDesktop(sliderComponent)) {
            updateThumbnailButtonStates(sliderComponent);
          }
        });
      }
    });
    
    const mediaItems = sliderComponent.slider.querySelectorAll('li[data-media-id]');
    mediaItems.forEach((item) => {
      mediaObserver.observe(item, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
    
    mediaObserver.observe(sliderComponent.slider, {
      childList: true,
      subtree: false
    });
    
    const viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', () => {
        requestAnimationFrame(() => {
          if (isThumbnailLayoutDesktop(sliderComponent)) {
            updateThumbnailButtonStates(sliderComponent);
          }
        });
      });
    }
  }
  
  window.ProductMediaThumbnailNav = {
    isThumbnailLayoutDesktop,
    handleThumbnailNavigation,
    updateThumbnailButtonStates,
    setupThumbnailObservers
  };
})();

